import './AnalyticsDashboardPage.css';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { t } from 'i18next';
import NavBar from '../../subComponents/navBar/navBar';
import TitleBar from '../../../titleBar/TitleBar';

import CRUDTable from '../../subComponents/CRUDTable/CRUDTableComponent';
import FailurePredictionGraphComponent from
  '../../subComponents/TensorGraphs/FailurePredictionGraph/FailurePredictionGraphComponent';
import {
  anomalyCount, failureCount, forecastCount, anomalyJob, failureJob, forecastJob, anomalyJobInfo, getResultService,
  forecastJobInfo, aylaDeviceDetail, failureJobInfo, getPlotService, setSession, completedSchedules,
} from '../../services/testResultsService';
import { showError } from '../../../../reducer/actions';

class AnalyticsDashboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anomalyTable: [],
      dsnTable: [],
      failureData: [],
      failureTable: [],
      forecastTable: [],
      selectedJobName: '',
      selectedTab: 'anomaliesDetected',
      showFailureChart: false,
      tabData: {
        anomaliesDetected: '',
        forecastedEvent: '',
        predictedFailures: '',
      },
      threshold: 70,
      thresholdTimeout: 0,
      timeSpan: 1,
    };
    this.thresholdChangeHandler = this.thresholdChangeHandler.bind(this);
  }

  componentDidMount() {
    this.setOEM();
    this.getCompletedJobs();
    this.getCounts();
    this.getDailyJobs();
  }

  setOEM = () => {
    const { session } = this.props;
    setSession(session);
  }

  getCompletedJobs() {
    const { dispatch } = this.props;
    completedSchedules().then(res => {
      this.setState({
        completedJobs: res.body
      });
    }, err => dispatch(showError({
      status: '',
      statusText: `${err} error`
    })));
  }

  getCounts() {
    const { tabData, timeSpan } = this.state;
    anomalyCount(timeSpan).then((result) => {
      tabData.anomaliesDetected = result.count;
      this.setState({
        tabData,
      });
    });
    failureCount(timeSpan).then((result) => {
      tabData.predictedFailures = result.count;
      this.setState({
        tabData,
      });
    });
    forecastCount(timeSpan).then((result) => {
      tabData.forecastedEvent = result.count;
      this.setState({
        tabData,
      });
    });
  }

  getDailyJobs() {
    const { timeSpan } = this.state;
    anomalyJob(timeSpan).then((result) => {
      this.setState({
        anomalyTable: result,
      });
    });
    failureJob(timeSpan).then((result) => {
      // console.log(result);
      this.setState({
        failureTable: result,
      });
    });
    forecastJob(timeSpan).then((result) => {
      this.setState({
        forecastTable: result,
      });
    });
  }

  getFailurePlot(jobName) {
    const { dispatch } = this.props;
    // let jobName = "611PctDiffCDF";
    // Request plot data and setup LineChart graph data

    getPlotService(jobName).then((requestData) => {
      // console.log(requestData)
      // If using cumalative distribution as jobname multiple y by 100
      requestData['X-Axis'].reverse();
      const failureData = requestData['X-Axis'].map((dataXPoint, index) => ({
        x: parseInt(dataXPoint, 10),
        y: parseInt(requestData['Y-Axis'][index], 10)
      }));
      this.setState({
        failureData
      });
    }).catch((error) => {
      dispatch(showError({
        status: error,
        statusText: 'Error',
      }));
    });
  }

  changeTimespan = (e) => {
    const timeSpan = e.target.value;
    const convertedTimeSpan = Number(timeSpan);
    this.setState({
      timeSpan: convertedTimeSpan
    }, () => {
      this.getCounts();
      this.getDailyJobs();
    });
  }

  populateDsnTable(data) {
    this.setState({
      dsnTable: data,
    });
  }

  changeTab(selectedTab) {
    this.setState({
      dsnTable: [],
      selectedTab,
    });
  }

  // Threshold handler from Graph
  thresholdChangeHandler(newThreshold) {
    const {
      thresholdTimeout, selectedJobName, selectedTab, dsnTable
    } = this.state;

    if (selectedTab !== 'predictedFailures') return;

    if (thresholdTimeout) {
      clearTimeout(thresholdTimeout);
    }

    let threshold = newThreshold;
    if (newThreshold === 100) threshold = 95;

    this.setState({
      thresholdTimeout: setTimeout(() => {
        getResultService(selectedJobName, threshold).then((result) => {
          const resultDeviceList = result.map(failure => failure.device);
          // console.log(resultDeviceList);
          const devicesToFail = dsnTable.filter(device => resultDeviceList.includes(device.DSN));
          // console.log(devicesToFail);
          this.populateDsnTable(devicesToFail);
        });
        this.setState({
          threshold,
        });
      }, 1000),
    });
  }

  jobInfo(jobName) {
    const {
      selectedTab, timeSpan, completedJobs
    } = this.state;
    const { session: { access_token } } = this.props;
    const jobInfo = Array.isArray(completedJobs) && completedJobs.filter(job => job.JobName === jobName);
    let cdfChart = false;
    if (jobInfo[0].ModelPlotType === 'Cumulative Distribution Function') {
      this.getFailurePlot(jobName);
      cdfChart = true;
    }
    this.setState({
      selectedJobName: jobName,
      showFailureChart: cdfChart

    });
    let request = () => {};
    if (selectedTab === 'predictedFailures') {
      request = failureJobInfo(jobName, timeSpan);
    } else if (selectedTab === 'forecastedEvent') {
      request = forecastJobInfo(jobName, timeSpan);
    } else {
      request = anomalyJobInfo(jobName, timeSpan);
    }
    request.then((result) => {
      // console.log(result);
      // Must used commented line when hooked to backend.
      // const requests = result.map((device) => aylaDeviceDetail(access_token, device.DSN));
      const requests = result.map(() => aylaDeviceDetail(access_token));
      Promise.all(requests).then(deviceDetail => {
        // console.log(deviceDetail);
        this.populateDsnTable(result.map((device, index) => ({
          ...device,
          Location: deviceDetail[index].device.locality,
          Status: deviceDetail[index].device.connection_status === 'Online',
        })));
      });
      this.populateDsnTable(result);
    });
  }

  render() {
    const columnsJobNameTable = [{
      accessor: 'jobName',
      Header: t('tensorAnalytics.tableHeaders.anomalyType'),
    }, {
      accessor: 'AnomalyCount',
      Cell: row => (
        <div style={{
          textAlign: 'center',
        }}
        >
          {row.value}
        </div>
      ),
      Header: t('tensorAnalytics.tableHeaders.numberOfDevices'),
      width: 90,
    }, {
      accessor: 'AnomalyPercent',
      Cell: row => (
        <div style={{
          textAlign: 'center',
        }}
        >
          {`${row.value}%`}
        </div>
      ),
      Header: t('tensorAnalytics.tableHeaders.percentDevices'),
      width: 80,
    }];

    const columnsAnomalyListTable = [{
      accessor: 'Status',
      Cell: row => (
        <div>
          <span className={`status ${row.value ? 'green' : 'red'}`} />
        </div>
      ),
      Header: t('tensorAnalytics.tableHeaders.status'),
      width: 65,
    }, {
      accessor: 'DSN',
      Cell: row => {
        const { selectedJobName: selectedJob } = this.state;
        return (
          <Link to={{
            pathname: `/deviceDetail/${row.value}`,
            state: {
              selectedJob
            }
          }}
          >
            {row.value}
          </Link>
        );
      },
      Header: t('tensorAnalytics.tableHeaders.DSN'),
      width: 180,
    }, {
      accessor: 'Location',
      Header: t('tensorAnalytics.tableHeaders.location'),
    }, {
      accessor: 'Severity',
      Cell: row => (
        <div style={{
          textAlign: 'center',
        }}
        >
          {row.value}
        </div>
      ),
      Header: t('tensorAnalytics.tableHeaders.severity'),
      width: 100,
    }, {
      accessor: 'DateFirst',
      Cell: (row) => {
        const date = moment(row.value, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
        return (
          <div style={{
            textAlign: 'center',
          }}
          >
            {date.isValid() ? date.format('MM/DD/YY') : 'N/A'}
          </div>
        );
      },
      Header: t('tensorAnalytics.tableHeaders.dateDetected'),
      width: 110,
    }, {
      accessor: 'DaysIssue',
      Cell: row => (
        <div style={{
          textAlign: 'center',
        }}
        >
          {row.value}
        </div>
      ),
      Header: t('tensorAnalytics.tableHeaders.daysSinceActiveIssues'),
    }];

    const tabTitleText = (text) => {
      switch (text) {
        case 'anomaliesDetected':
          return 'Anomalies Detected';
        case 'predictedFailures':
          return 'Predicted Failures';
        case 'forecastedEvent':
          return 'Forecasted Event';
        default:
          return 'Other';
      }
    };

    const {
      selectedTab, selectedJobName, tabData, anomalyTable, failureTable, forecastTable,
      dsnTable, threshold, timeSpan, showFailureChart, failureData,
    } = this.state;
    let leftTableData;
    let noRowText;
    if (selectedTab === 'forecastedEvent') {
      leftTableData = forecastTable;
      noRowText = t('tensorAnalytics.analyticsDashboardPage.noEventsForecaster');
    } else if (selectedTab === 'predictedFailures') {
      leftTableData = failureTable;
      noRowText = t('tensorAnalytics.analyticsDashboardPage.noFailuresPredicted');
    } else {
      leftTableData = anomalyTable;
      noRowText = t('tensorAnalytics.analyticsDashboardPage.noAnomaliesDetected');
    }

    return (
      <div className="AnalyticsDashboardPage page">
        <TitleBar title={t('tensorAnalytics.analyticsDashboardPage.title')} />
        <NavBar />
        <div className="main-content">
          {/* Filter Panel */}
          <div className="timespan">
            <p>Timespan View</p>
            <select name="timeSpan" id="" value={timeSpan}
              onChange={this.changeTimespan}
            >
              <option value={1}>24 hours</option>
              <option value={7}>1 week</option>
              <option value={14}>2 weeks</option>
              <option value={30}>1 month</option>
            </select>
          </div>
          <div className="tabs">
            {Object.keys(tabData).map((tab, index) => (
              <div className={`tab ${selectedTab === tab ? 'selected' : ''}`}
                onClick={() => this.changeTab(tab)}
                onKeyDown={() => this.changeTab(tab)}
                tabIndex={index}
                role="button"
                key={tab}
              >
                <div className="tabTitle">
                  {tabTitleText(tab)}
                </div>
                <div className="tabCount">
                  {tabData[tab]}
                </div>
              </div>
            ))}
          </div>

          <div className="dashboardSection">
            <div className="dashboardBox full">
              <div className="dashboardBoxTitle">{tabTitleText(selectedTab)}</div>
              <div className="dashboardBoxContent lists">
                <div className="anomalyTypes">
                  <CRUDTable data={leftTableData}
                    columns={columnsJobNameTable}
                    style={{
                      maxHeight: '200px',
                    }}
                    noDataText={noRowText}
                    getTrProps={(state, rowInfo) => ({
                      className: (rowInfo && rowInfo.original.jobName === selectedJobName) ? 'selectable' : '',
                      onClick: rowInfo ? () => {
                        this.jobInfo(rowInfo.original.jobName);
                      } : null,
                      style: {
                        backgroundColor:
                          (rowInfo && rowInfo.original.jobName === selectedJobName) ? '#D7EFF5' : 'initial',
                      },
                    })}
                  />
                </div>
                <div className="anomalyList">
                  <CRUDTable data={dsnTable}
                    columns={columnsAnomalyListTable}
                    style={{
                      maxHeight: '200px',
                    }}
                    noDataText={noRowText}
                    options={{
                      exportToCSV: true,
                      exportToCSVOptions: {
                        fileName: `anomalies-${moment().format('DD/MM/YYYY')}`,
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="dashboardSection">
            <div className="dashboardBox">
              {/* <div className="dashboardBoxTitle"></div> */}
              <div className="dashboardBoxContent">
                {/* {'Graph Content 1'} */}
              </div>
            </div>
            <div className="dashboardBox">
              {/* <div className="dashboardBoxTitle"></div> */}
              <div className="dashboardBoxContent">
                {/* {'Graph Content 2'} */}
              </div>
            </div>
            {
              selectedTab === 'predictedFailures' && (
                <div className="dashboardBox">
                  { ! showFailureChart ? (
                    <div className="dashboardBoxTitle">Select a CDF job to display graph</div>
                  ) : (
                    <React.Fragment>
                      <div className="dashboardBoxTitle"> CDF Failure Prediction Graph </div>
                      <div className="dashboardBoxContent">
                        {failureData.length > 0 && (
                          <FailurePredictionGraphComponent height={350} changeThreshold={this.thresholdChangeHandler}
                            fromPlotService
                            failureData={failureData}
                            threshold={threshold}
                          />
                        )}
                      </div>
                    </React.Fragment>
                  )
                  }
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(AnalyticsDashboardPage);
